module.exports = __webpack_public_path__ + "static/media/banner-property-managers.e8b53f9e.jpg";